import React from "react";
import { AlertCircle, Calendar, CheckCircle } from "lucide-react";

export default function CancellationPolicy() {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-sm rounded-2xl overflow-hidden">
        
        {/* HEADER */}
        <div className="bg-[#003580] px-8 py-10 text-center">
          <h1 className="text-3xl font-bold text-white">Cancellation & Refund Policy</h1>
          <p className="text-blue-100 mt-2">
            Transparent rules for a worry-free booking experience with Highend Holidays Homes.
          </p>
        </div>

        {/* CONTENT */}
        <div className="px-8 py-10 space-y-8">
          
          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
              <Calendar className="text-blue-600" size={20} />
              Standard Cancellation Terms
            </h2>
            <div className="space-y-4 text-gray-600 text-sm leading-relaxed">
              <p>
                We understand that travel plans can change. Our cancellation policy is designed to be fair to both our guests and our property owners.
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  <strong className="text-gray-900">Free Cancellation:</strong> You may cancel your reservation for free up to <strong>14 days</strong> before your scheduled check-in date. A full refund will be processed to your original payment method.
                </li>
                <li>
                  <strong className="text-gray-900">Partial Refund:</strong> Cancellations made between <strong>7 and 14 days</strong> prior to check-in are eligible for a 50% refund of the total booking value.
                </li>
                <li>
                  <strong className="text-gray-900">Non-Refundable:</strong> Cancellations made within <strong>7 days</strong> of the check-in date are non-refundable.
                </li>
              </ul>
            </div>
          </section>

          <hr className="border-gray-100" />

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
              <CheckCircle className="text-green-600" size={20} />
              Refund Process
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Refunds are processed immediately upon cancellation confirmation. Depending on your bank or credit card provider, it may take <strong>5–10 business days</strong> for the funds to appear in your account.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-600 p-4">
              <p className="text-sm text-blue-800">
                <strong>Note:</strong> Transaction fees (if applicable) or currency conversion differences charged by your bank are not covered by Highend Holidays Homes.
              </p>
            </div>
          </section>

          <hr className="border-gray-100" />

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
              <AlertCircle className="text-red-500" size={20} />
              Force Majeure & Special Circumstances
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              In the event of government-mandated lockdowns, border closures, or natural disasters that prevent travel to Dubai, we will offer a <strong>full credit voucher</strong> valid for 12 months, or a full refund depending on the specific situation. This allows you to reschedule your stay without penalty.
            </p>
          </section>

          {/* Contact Footer */}
          <div className="mt-8 pt-8 border-t border-gray-200 text-center">
            <p className="text-sm text-gray-500">
              Have questions about a specific booking?
            </p>
            <a href="/contact" className="text-blue-600 font-semibold hover:underline mt-1 block">
              Contact our Support Team
            </a>
          </div>

        </div>
      </div>
    </div>
  );
}